module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/mobile-757b2c74b5d2329629a8e49b5929924b.webp";